import SidePanel from "@Common/SidePanel";
import { useTestCaseContext } from "@Context/TestCaseContext";
import TestRailHistory from "./TestRailHistory";
import DefaultView from "./DefaultView";
import GeneratedView from "./generated/GeneratedView";

const SidePanelWrapper = () => {
  const { viewType } = useTestCaseContext();

  return (
    <SidePanel position="right">
      {viewType === "" && <DefaultView />}
      {viewType === "TestRail" && <TestRailHistory />}
      {viewType === "TestCases" && <GeneratedView />}
    </SidePanel>
  );
};

export default SidePanelWrapper;
